import BaseServices from "./BaseServices";

const PartnerServices = {
    AssignPartner: async (id) => {
        return await BaseServices.Post("/api/partner/assign-partner/" + id, null);
    },
    DeletePartner: async (id) => {
        return await BaseServices.Post("/api/partner/delete-partner/" + id, null);
    },
    GetPartnerUserModel: async (page) => {
        return await BaseServices.Post("/api/partner/get-partner-users", page);
    },
    GetPartnerById: async (id) => {
        return await BaseServices.Get("/api/partner/get-partner-by-id/" + id);
    },
    AddProductPartner: async (model) => {
        return await BaseServices.Post("/api/partner/add-product-partner", model);
    },
    CreateUpdatePartner: async (model) => {
        return await BaseServices.Post("/api/partner/create-update-partner", model);
    },
    UpdateRangePartner: async (list) => {
        return await BaseServices.Post("/api/partner/update-range-partner", list);
    },
    GetPartnerModelById: async (id) => {
        return await BaseServices.Get("/api/partner/get-partner-model-by-id/" + id);
    },
    GetPartnerCostById: async (id) => {
        return await BaseServices.Get("/api/partner/get-partner-cost-by-id/" + id);
    },
    UpdatePartnerTotalCost: async (model) => {
        return await BaseServices.Post("/api/partner/update-partner-total", model);
    },
    GetPartnerLogoAsync: async (id) => {
        return await BaseServices.Get("/api/partner/get-partner-logo/" + id);
    },
    CreateUpdatePartnerLogo: async (model) => {
        return await BaseServices.Post("/api/partner/create-update-partner-logo", model);
    },
    GetAppPartnerCostDiscountByPage: async (page) => {
        return await BaseServices.Post("/api/partner/get-app-partner-cost-discount-by-page", page);
    },
    CreateUpdatePartnerCostDiscount: async (model) => {
        return await BaseServices.Post("/api/partner/create-update-partner-cost-discount", model);
    },
    GetPartnerCostDiscountById: async (id) => {
        return await BaseServices.Get("/api/partner/get-partner-cost-discount-by-id/" + id);
    },
    RemovePartnerCostDiscount: async (id) => {
        return await BaseServices.Get("/api/partner/remove-partner-cost-discount/" + id);
    },
    GetPartnerCostDiscountByComboId: async (id) => {
        return await BaseServices.Get("/api/partner/get-partner-cost-discount-by-combo-id/" + id);
    },
    GetPartnerCostDiscountCombo: async (page) => {
        return await BaseServices.Post("/api/partner/get-partner-cost-discount-combo", page);
    },
    CreateUpdatePartnerCostCombo: async (model) => {
        return await BaseServices.Post("/api/partner/create-update-partner-cost-combo", model);
    },
};

export default PartnerServices;
